<div class="emds">
  <div class="modal-default modal-flex" id="findcontrol-reorder-columns-modal">
    <div class="modal-header">
      <span translate>Modify Columns - Reorder columns for {{ findControlBehavior.Name }}</span>
    </div>
    <div class="modal-body">
      <div>
        <table
          mat-table
          #table
          id="findcontrol-reorder-columns-modal-table"
          [dataSource]="columnList"
          class="mat-elevation-z0 table emds-table table-striped table-borderless table-sticky-header table-fixed"
          cdkDropList
          [cdkDropListData]="columnList"
          (cdkDropListDropped)="reorderedRow($event)"
        >
          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef class="column-content-width">&nbsp;<!--drag handle--></th>
            <td mat-cell *matCellDef="let element">
              <mat-icon cdkDragHandle class="reorder-columns-drag-handle" id="findcontrol-reorder-columns-modal-drag-{{element.Name}}">drag_handle</mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="Visible">
            <th mat-header-cell *matHeaderCellDef class="column-content-width">
              <mat-checkbox id="findcontrol-reorder-columns-modal-all-visible-checkbox" [(ngModel)]="allVisible" (ngModelChange)="onAllVisibleChange()">Visible</mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element" class="column-content-checkbox">
              <mat-checkbox [(ngModel)]="element.Visible" (ngModelChange)="onColumnVisibleChange()" id="findcontrol-reorder-columns-modal-visible-{{element.Name}}"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="Name">
            <th mat-header-cell *matHeaderCellDef class="column-header-middle">
              <span>Column</span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span>{{ element.Name }}</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></tr>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button id="findcontrol-reorder-columns-modal-close"
              class="btn-primary btn pull-right"
              (click)="close()"
              translate>
          Save
      </button>
      <button id="findcontrol-reorder-columns-modal-reset"
              class="btn btn-light"
              (click)="onReset()"
              translate>
          Reset
      </button>
      <button id="findcontrol-reorder-columns-modal-cancel"
              class="btn pull-right btn-flush-right"
              (click)="cancel()"
              translate>
          Cancel
      </button>
    </div>
  </div>
</div>